import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4" data-id="element-127">
      <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 50
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-128">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-129">
          El problema real{' '}
          <span className="text-cyan-400" data-id="element-130">
            (y por qué se siente tan personal)
          </span>
        </h2>

        <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-131">
          <p data-id="element-132">
            Cuando no sales en cámara, sientes que estás compitiendo en
            desventaja.
          </p>
          <p data-id="element-133">
            Como si el mundo premiara al extrovertido. Como si tu única forma de
            ganar fuera "venderte" o "actuar".
          </p>
          <p data-id="element-134">Entonces haces lo lógico: buscas una app, un tutorial, un hack.</p>
          <p className="font-semibold text-white" data-id="element-135">
            Pero lo que te pasa después es siempre igual:
          </p>
          <ul className="space-y-3 pl-6" data-id="element-136">
            <li className="flex items-start" data-id="element-137">
              <span className="text-cyan-400 mr-3" data-id="element-138">•</span>
              <span data-id="element-139">te queda un avatar "bonito"… pero no publicable</span>
            </li>
            <li className="flex items-start" data-id="element-140">
              <span className="text-cyan-400 mr-3" data-id="element-141">•</span>
              <span data-id="element-142">te sale un video… pero no sabes repetirlo</span>
            </li>
            <li className="flex items-start" data-id="element-143">
              <span className="text-cyan-400 mr-3" data-id="element-144">•</span>
              <span data-id="element-145">un día te sientes bien… y al otro lo odias</span>
            </li>
            <li className="flex items-start" data-id="element-146">
              <span className="text-cyan-400 mr-3" data-id="element-147">•</span>
              <span data-id="element-148">y terminas pensando que el problema eres tú</span>
            </li>
          </ul>
          <p className="text-xl font-bold text-cyan-400 mt-8" data-id="element-149">No.</p>
          <p className="text-xl font-semibold text-white" data-id="element-150">
            El problema es que estás intentando construir una casa sin
            estructura.
          </p>
        </div>
      </motion.div>
    </section>;
}